import { render, staticRenderFns } from "./PageCustomDashboard.vue?vue&type=template&id=b72dc434&scoped=true"
import script from "./PageCustomDashboard.vue?vue&type=script&lang=js"
export * from "./PageCustomDashboard.vue?vue&type=script&lang=js"
import style0 from "./PageCustomDashboard.vue?vue&type=style&index=0&id=b72dc434&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72dc434",
  null
  
)

export default component.exports